<p-table *ngIf="countryLocation == 'PL'" #dt [value]="currentScreenData" [paginator]="true" 
    [rowsPerPageOptions]="[5, 10, 25, 50]" [rows]="5" [(selection)]="selectedRows" [showCurrentPageReport]="true"
    currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
    sortMode="multiple" [resizableColumns]="true" columnResizeMode="expand" [tableStyle]="{'min-width': 'fit-content'}"
    [globalFilterFields]="['Date', 'System_ID', 'Source', 'FileType', 'FileID', 'OrgFileName', 'Status', 'Total_Received', 'TransformationName', 'Structure','Active_Errors','Active', 'In_Progress_KSeF', 'Success_KSeF', 'Errors_KSeF']">
    
    <ng-template pTemplate="caption">
        <div class="p-d-flex search-input d-flex justify-content-end">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                    placeholder="{{'text.Searchkeyword' | translate}}" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th rowspan="0" pSortableColumn="Date" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.date' | translate}}
                    <p-columnFilter type="text" field="Date" display="menu"></p-columnFilter>
                    <p-sortIcon field="Date"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="System_ID" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.sysID' | translate}}
                    <p-columnFilter type="text" field="System_ID" display="menu"></p-columnFilter>
                    <p-sortIcon field="System_ID"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="Source" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.source' | translate}}
                    <p-columnFilter type="text" field="Source" display="menu"></p-columnFilter>
                    <p-sortIcon field="Source"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="FileType" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileType' | translate}}
                    <p-columnFilter type="text" field="FileType" display="menu"></p-columnFilter>
                    <p-sortIcon field="FileType"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="FileID" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileID' | translate}}
                    <p-columnFilter type="text" field="FileID" display="menu"></p-columnFilter>
                    <p-sortIcon field="FileID"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" style="width: 10%;" pSortableColumn="OrgFileName" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileName' | translate}}
                    <p-columnFilter type="text" field="OrgFileName" display="menu"></p-columnFilter>
                    <p-sortIcon field="OrgFileName"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="Status" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.status' | translate}}
                    <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                    <p-sortIcon field="Status"></p-sortIcon>
                </div>
            </th>
            <th style="display:none;" rowspan="0">{{'text.interMOF' | translate}}</th>
            <th rowspan="0" pSortableColumn="Total_Received" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.totalrec' | translate}}
                    <p-columnFilter type="text" field="Total_Received" display="menu"></p-columnFilter>
                    <p-sortIcon field="Total_Received"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="TransformationName" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.transform' | translate}}
                    <p-columnFilter type="text" field="TransformationName" display="menu"></p-columnFilter>
                    <p-sortIcon field="TransformationName"></p-sortIcon>
                </div>
            </th>
            <th pSortableColumn="Active_Errors" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.activeErr' | translate}}
                    <p-columnFilter type="text" field="Active_Errors" display="menu"></p-columnFilter>
                    <p-sortIcon field="Active_Errors"></p-sortIcon>
                </div>
            </th>
            <th pSortableColumn="Active" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.active' | translate}}
                    <p-columnFilter type="text" field="Active" display="menu"></p-columnFilter>
                    <p-sortIcon field="Active"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="In_Progress_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.inprogressKSeF' | translate}}
                    <p-columnFilter type="text" field="In_Progress_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="In_Progress_KSeF"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="Success_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.successKSeF' | translate}}
                    <p-columnFilter type="text" field="Success_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="Success_KSeF"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="Errors_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.errorsKSeF' | translate}}
                    <p-columnFilter type="text" field="Errors_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="Errors_KSeF"></p-sortIcon>
                </div>
            </th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-currentScreenData>
        <tr>
            <td>
                <!-- [disabled]='currentScreenData.status != "Processed" || tin.prossRecords == 0' -->
                {{currentScreenData.Date | date:'yyyy-MM-dd HH:mm:ss'}}
            </td>
            <td>{{userList[currentScreenData.System_ID] ? userList[currentScreenData.System_ID] :
                currentScreenData.System_ID}}</td>
            <td>{{currentScreenData.Source}}</td>
            <td>
                {{currentScreenData.FileType}}
            </td>
            <td>{{currentScreenData.FileID}}</td>
            <td style="width: 10%; word-break: break-all;">{{currentScreenData.OrgFileName}}</td>
            <td>
                <span *ngIf="currentScreenData.Interfacing_with_MoF === 'AUTO'" class="td-auto file-status"
                    [ngStyle]="{'background-color': setStatusColor(currentScreenData), 'color': getTextColor(currentScreenData?.Status)}">
                    {{fileStatus1(currentScreenData)?.[currentScreenData?.Status]?.text}}<span
                        *ngIf="inProgressStatus(currentScreenData)"> -
                        {{progressList[currentScreenData.Stage]}}%</span>
                    <i *ngIf="handleTooltip(currentScreenData)" class="me-2" style='color: #9ca3a8;'
                        class="pi pi-info-circle" pTooltip="{{currentScreenData.Error}}"></i>
                </span>
                <span *ngIf="currentScreenData.Interfacing_with_MoF !== 'AUTO'" class="td-auto file-status"
                    [ngStyle]="{'background-color': setStatusColorNONAuto(currentScreenData), 'color': getTextColor(currentScreenData?.Status)}">
                    {{fileStatus1(currentScreenData)?.[currentScreenData?.Status]?.text}} <span
                        *ngIf="currentScreenData.Interfacing_with_MoF !== 'AUTO' && eyFileStatus(currentScreenData)"> -
                        {{progressList[currentScreenData.Stage]}}%</span>
                    <i *ngIf="toolTipNonAuto(currentScreenData)" class="me-2" style='color: #9ca3a8;'
                        class="pi pi-info-circle" pTooltip="{{currentScreenData.Error}}"></i>
                </span>
                <i *ngIf="currentScreenData?.Status?.toLowerCase() === 'pending'" style='color: #155cb4; cursor: pointer;'
                    class="ms-1 pi pi-upload" [id]="'uploadIcon_' + currentScreenData?.FileID"
                    (click)="openUploadAttachmentDialog(currentScreenData)">
                </i>
            </td>
            <td style="display:none;">{{currentScreenData.Interfacing_with_MoF === "AUTO" ? "Automated"
                : (currentScreenData.Interfacing_with_MoF === "MANUAL" ? "Manual"
                : currentScreenData.Interfacing_with_MoF)}}</td>
            <td *ngIf="currentScreenData.FileStandard === 'EY'" class="download-icon">{{currentScreenData.Total_Received
                || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_TOTAL'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Total_Received
                    [fileStandard]="currentScreenData.FileStandard" [fileExt]="'default'"
                    [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td *ngIf="currentScreenData.FileStandard === 'NONEY'" class="download-icon">
                {{currentScreenData.Total_Received || '-' }}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_TOTAL'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Total_Received
                    [fileStandard]="currentScreenData.FileStandard" [fileExt]="'default'" [bypassCheck]=true
                    [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                     [transform]="currentScreenData.Type" [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable === true" >
                </download-data>
            </td>
            <td class="download-icon">{{currentScreenData.TransformationName}}
                <download-data *ngIf="currentScreenData.FileStandard === 'NONEY' && currentScreenData.Status !== 'PREUPLOADED'
                && currentScreenData.Status !== 'T_INPROGRESS'" [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate"
                    [fileName]="currentScreenData.FileName" [fileType]="'EY_TRANSFORMATION'"
                    [fileId]="currentScreenData.FileID" [count]=currentScreenData.Transformation [bypassCheck]=true
                    [fileExt]="'csv'" [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type" [fileStatus]="noneyfileStatusList[currentScreenData.Status]
                ? noneyfileStatusList[currentScreenData.Status]['text'] : currentScreenData.Status"
                    [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable === true"></download-data>
            </td>
            <td class="download-icon">{{currentScreenData.Active_Errors || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_ACTIVE_ERRORS'" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Active_Errors [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td class="download-icon">{{currentScreenData.Active || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_ACTIVE'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Active
                    [source]="currentScreenData.Source"
                    [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td *ngIf='!isManual'>{{currentScreenData.In_Progress_KSeF || 0}}
            </td>
            <td *ngIf='!isManual' class="download-icon">{{currentScreenData.Success_KSeF || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'MOF_SUCCESS'" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Success_KSeF [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td *ngIf='!isManual' class="download-icon">{{currentScreenData.Errors_KSeF || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'MOF_ERROR'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Errors_KSeF
                    [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="0">{{'text.noData' | translate}}</td>
        </tr>
    </ng-template>
</p-table>
<div [ngClass]="{ 'card': isSidebarLayout }" [ngStyle]="isSidebarLayout ? {'margin': '1rem'} : {}">
<p-table *ngIf="countryLocation !== 'PL' && countryLocation !== 'IT'" #dt [value]="currentScreenData"
    [paginator]="true"
    [rowsPerPageOptions]="isSidebarLayout ? lazyRowsPerPageOptions : [5, 10, 25, 50]"
    [rows]="isSidebarLayout ? lazyRows : 5"
    [lazy]="isSidebarLayout"
    [totalRecords]="isSidebarLayout ? totalRecords : undefined"
    (onPage)="isSidebarLayout && onPageEvent($event)"
    (onSort)="isSidebarLayout && onSortEvent($event)"
    [(selection)]="selectedRows" [showCurrentPageReport]="true"
    [currentPageReportTemplate]="isSidebarLayout && footerMessage ? footerMessage : (('text.showing' | translate) + ' {first} ' + ('text.to' | translate) + ' {last} ' + ('text.of' | translate) + ' {totalRecords} ' + ('text.entries' | translate))"
    [customSort]="!isSidebarLayout" (sortFunction)="!isSidebarLayout && customSortFunction($event)" [resizableColumns]="true" columnResizeMode="expand" [tableStyle]="{'min-width': 'fit-content'}"
    [globalFilterFields]="['Date', 'System_ID', 'Source', 'FileType', 'FileID', 'OrgFileName', 'GVRT_Status', 'Status', 'Total_Received', 'TransformationName', 'Structure','Active_Errors','Active', 'In_Progress_KSeF', 'Success_KSeF', 'Errors_KSeF']">
    <ng-template pTemplate="sorticon" let-sortOrder>
        <ng-container *ngIf="isSidebarLayout; else defaultSortIcon">
            <span class="custom-sort-icon">
                <i *ngIf="sortOrder === 0" class="pi pi-angle-up sort-default"></i>
                <i *ngIf="sortOrder === 0" class="pi pi-angle-down sort-default"></i>
                <i *ngIf="sortOrder === 1" class="pi pi-angle-up sort-active"></i>
                <i *ngIf="sortOrder === -1" class="pi pi-angle-down sort-active"></i>
            </span>
        </ng-container>
        <ng-template #defaultSortIcon>
            <i *ngIf="sortOrder === 0" class="pi pi-sort-alt"></i>
            <i *ngIf="sortOrder === 1" class="pi pi-sort-amount-up-alt"></i>
            <i *ngIf="sortOrder === -1" class="pi pi-sort-amount-down"></i>
        </ng-template>
    </ng-template>
    <ng-template pTemplate="caption">
        <div class="p-d-flex search-input d-flex justify-content-end">
            <ng-container *ngIf="isSidebarLayout">
                <download-table [type]="'buttonTP'" [ngClass]="{'fr-proto-outline-download-btn': selectedCountry === 'FR'}"
                    [btnName]="'text.download' | translate" [tableData]="tableData" [tableType]="downloadTblType"
                    [userList]="userList" [selectedRows]="getSelectedRows()"
                    (onDownloadTableData)="downloadTableData.emit($event)"
                    (clearSelectedRows)="onClearSelectedRows($event)">
                </download-table>

                <div class="tbar-spacer"></div>

                <label for="switch1" class="slider-label m-2">{{'text.automated' | translate}}</label>
                <p-inputSwitch [(ngModel)]="mofCheck"
                    inputId="switch1" (onChange)="mofCheckChange.emit(mofCheck); switchMofChange.emit()">
                </p-inputSwitch>
                <label class="m-2">{{'text.manual' | translate}}</label>

                <button class="tbar-refresh-btn" (click)="refreshClick.emit()" aria-label="refresh" title="Refresh">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                </button>

                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input #globalFilterInput pInputText type="text" [(ngModel)]="globalSearchText" tooltipPosition="left"
                        (input)="onGlobalSearch($event.target.value)"
                        [pTooltip]="'text.searchTooltipMessage' | translate"
                        placeholder="{{'text.Search' | translate}}" />
                </span>

                <button class="tbar-flat-btn" aria-label="filter"
                    (click)="showFilterSideBar = true; showFilterSideBarChange.emit(true)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="11" x2="17" y2="11"/><line x1="10" y1="16" x2="14" y2="16"/></svg>
                    {{ 'text.filter' | translate }}
                </button>
                <app-filter-sidebar [(visible)]="showFilterSideBar" [fields]="filterFields"
                    [activeFilters]="activeFilters" [title]="filterSidebarTitle" submitLabel="text.submitLabel"
                    (filterSubmit)="onFilterSubmit($event)" (filterClear)="filterClear.emit($event)"
                    (visibleChange)="showFilterSideBarChange.emit($event)">
                </app-filter-sidebar>
            </ng-container>
            <ng-container *ngIf="!isSidebarLayout">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{'text.Searchkeyword' | translate}}" />
                </span>
            </ng-container>
        </div>
        <app-filter-chips *ngIf="isSidebarLayout"
            [activeFilters]="activeFilters"
            [fields]="filterFields"
            (removeFilter)="onChipRemove($event)"
            (clearAllFilters)="onChipClearAll()">
        </app-filter-chips>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th *ngIf="isSidebarLayout" style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th rowspan="0" pSortableColumn="Date" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.date' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Date" display="menu"></p-columnFilter>
                    <p-sortIcon field="Date"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="System_ID" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.sysID' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="System_ID" display="menu"></p-columnFilter>
                    <p-sortIcon field="System_ID"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="Source" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.source' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Source" display="menu"></p-columnFilter>
                    <p-sortIcon field="Source"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="FileType" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileType' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="FileType" display="menu"></p-columnFilter>
                    <p-sortIcon field="FileType"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="FileID" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileID' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="FileID" display="menu"></p-columnFilter>
                    <p-sortIcon field="FileID"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" style="width: 10%;" pSortableColumn="OrgFileName" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileName' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="OrgFileName" display="menu"></p-columnFilter>
                    <p-sortIcon field="OrgFileName"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" [pSortableColumn]="isSidebarLayout ? null : 'Status'" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.status' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Status" display="menu"></p-columnFilter>
                    <p-sortIcon *ngIf="!isSidebarLayout" field="Status"></p-sortIcon>
                </div>
            </th>
            <th style="display:none;" rowspan="0">{{'text.interMOF' | translate}}</th>
            <th rowspan="0" pSortableColumn="Total_Received" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.totalrec' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Total_Received" display="menu"></p-columnFilter>
                    <p-sortIcon field="Total_Received"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="TransformationName" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.transform' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="TransformationName" display="menu"></p-columnFilter>
                    <p-sortIcon field="TransformationName"></p-sortIcon>
                </div>
            </th>
            <th pSortableColumn="Active_Errors" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.activeErr' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Active_Errors" display="menu"></p-columnFilter>
                    <p-sortIcon field="Active_Errors"></p-sortIcon>
                </div>
            </th>
            <th pSortableColumn="Active" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.active' | translate}}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Active" display="menu"></p-columnFilter>
                    <p-sortIcon field="Active"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="In_Progress_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{ getColumnHeaderText('inprogress') }}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="In_Progress_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="In_Progress_KSeF"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="Success_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{ getColumnHeaderText('success') }}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Success_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="Success_KSeF"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="Errors_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{ getColumnHeaderText('error') }}
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="Errors_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="Errors_KSeF"></p-sortIcon>
                </div>
            </th>
            <th *ngIf="(countryLocation ==='RO' || countryLocation ==='MY') && displayGVRTcolumn" rowspan="0" pSortableColumn="GVRT_Status" pResizableColumn>
                <div class="d-flex align-items-center" [style.padding-right]="isManual ? '1rem' : null">
                    {{'text.gvrtStatus' | translate}}
                    <i class="me-2 pi pi-info-circle" tooltipPosition="top"
                       [pTooltip]="getTooltipData()"></i>
                    <p-columnFilter *ngIf="!isSidebarLayout" type="text" field="GVRT_Status" display="menu"></p-columnFilter>
                    <p-sortIcon field="GVRT_Status"></p-sortIcon>
                </div>
            </th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-currentScreenData>
        <tr>
            <td *ngIf="isSidebarLayout" style="width: 3rem">
                <p-tableCheckbox [value]="currentScreenData"></p-tableCheckbox>
            </td>
            <td>
                <!-- [disabled]='currentScreenData.status != "Processed"  || tin.prossRecords == 0' -->
                {{currentScreenData.Date | date:'yyyy-MM-dd HH:mm:ss'}}
            </td>
            <td>{{userList[currentScreenData.System_ID] ? userList[currentScreenData.System_ID] :
                currentScreenData.System_ID}}</td>
            <td> {{currentScreenData.Source}}</td>
            <td>
                {{currentScreenData.FileType}}
            </td>
            <td>{{currentScreenData.FileID}}</td>
            <td style="width: 10%; word-break: break-all;">{{currentScreenData.OrgFileName}}</td>
            <td>
                <span *ngIf="currentScreenData.Interfacing_with_MoF === 'AUTO'" class="td-auto file-status"
                    [ngStyle]="{'background-color': setStatusColor(currentScreenData), 'color': getTextColor(currentScreenData?.Status)}">
                    {{fileStatus1(currentScreenData)?.[currentScreenData?.Status]?.text}}<span
                        *ngIf="inProgressStatus(currentScreenData)"> -
                        {{progressList[currentScreenData.Stage]}}%</span>
                    <i *ngIf="handleTooltip(currentScreenData)" class="me-2" style='color: #9ca3a8;'
                        class="pi pi-info-circle" pTooltip="{{currentScreenData.Error}}"></i>
                </span>

                <span *ngIf="currentScreenData.Interfacing_with_MoF !== 'AUTO'" class="td-auto file-status"
                    [ngStyle]="{'background-color': setStatusColorNONAuto(currentScreenData), 'color': getTextColor(currentScreenData?.Status)}">
                    {{fileStatus1(currentScreenData)?.[currentScreenData?.Status]?.text}} <span 
                        *ngIf="currentScreenData.Interfacing_with_MoF !== 'AUTO' && eyFileStatus(currentScreenData)"> -
                        {{progressList[currentScreenData.Stage]}}%</span>
                    <i *ngIf="toolTipNonAuto(currentScreenData)" class="me-2" style='color: #9ca3a8;'
                        class="pi pi-info-circle" pTooltip="{{currentScreenData.Error}}"></i>
                </span>
                <i *ngIf="currentScreenData?.Status?.toLowerCase() === 'pending'" style='color: #155cb4; cursor: pointer;'
                    class="ms-1 pi pi-upload" [id]="'uploadIcon_' + currentScreenData?.FileID"
                    (click)="openUploadAttachmentDialog(currentScreenData)">
                </i>
            </td>
            <td style="display:none;">{{currentScreenData.Interfacing_with_MoF === "AUTO" ? "Automated"
                : (currentScreenData.Interfacing_with_MoF === "MANUAL" ? "Manual"
                : currentScreenData.Interfacing_with_MoF)}}</td>
            <td *ngIf="currentScreenData.FileStandard === 'EY'" class="download-icon">{{currentScreenData.Total_Received
                || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_TOTAL'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Total_Received
                    [fileStandard]="currentScreenData.FileStandard" [fileExt]="'default'"
                    [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td *ngIf="currentScreenData.FileStandard === 'NONEY'" class="download-icon">
                {{currentScreenData.Total_Received || '-' }}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_TOTAL'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Total_Received
                    [fileStandard]="currentScreenData.FileStandard" [fileExt]="'default'" [bypassCheck]=true
                    [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type" [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">

                </download-data>
            </td>
            <td class="download-icon">{{currentScreenData.TransformationName}}
                <download-data *ngIf="currentScreenData.FileStandard === 'NONEY' && currentScreenData.Status !== 'PREUPLOADED'
                && currentScreenData.Status !== 'T_INPROGRESS'" [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate"
                    [fileName]="currentScreenData.FileName" [fileType]="'EY_TRANSFORMATION'"
                    [fileId]="currentScreenData.FileID" [count]=currentScreenData.Transformation [bypassCheck]=true
                    [fileExt]="'csv'" [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type" [fileStatus]="noneyfileStatusList[currentScreenData.Status]
                ? noneyfileStatusList[currentScreenData.Status]['text'] : currentScreenData.Status"
                    [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">

                </download-data>
            </td>
            <td class="download-icon">{{currentScreenData.Active_Errors || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="tabName=='receipts'? 'EY_B2C_ACTIVE_ERRORS_'+countryLocation : currentScreenData?.FileType?.toUpperCase() === 'E-REPORTING' ? 'EY_EREPORT_ACTIVE_ERRORS_'+countryLocation : 'EY_ACTIVE_ERRORS_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Active_Errors [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [source]="currentScreenData.Source"
                    [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td class="download-icon">{{currentScreenData.Active || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="tabName=='receipts'? 'EY_B2C_ACTIVE_'+countryLocation : currentScreenData?.FileType?.toUpperCase() === 'E-REPORTING' ? 'EY_EREPORT_ACTIVE_'+countryLocation : 'EY_ACTIVE_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Active [source]="currentScreenData.Source" [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">
                </download-data>
            </td>

            <td *ngIf='!isManual'>{{currentScreenData.In_Progress_KSeF || 0}}
            </td>
            <td *ngIf='!isManual' class="download-icon">{{currentScreenData.Success_KSeF || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="currentScreenData?.FileType?.toUpperCase() === 'E-REPORTING' ? 'EREPORT_MOF_SUCCESS_'+countryLocation : 'MOF_SUCCESS_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Success_KSeF [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td *ngIf='!isManual' class="download-icon">{{currentScreenData.Errors_KSeF || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="currentScreenData?.FileType?.toUpperCase() === 'E-REPORTING' ? 'EREPORT_MOF_ERROR_'+countryLocation : 'MOF_ERROR_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Errors_KSeF [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
            <td *ngIf="(countryLocation ==='RO' || countryLocation ==='MY') && displayGVRTcolumn" class="download-icon">
                <span class="td-auto file-status"
                [ngStyle]="{'background-color': getGVRTStatus(currentScreenData?.GVRT_Status)?.bgColor, 'color': getGVRTStatus(currentScreenData?.GVRT_Status)?.color, 'margin-right' : '3px'}">
                    {{getGVRTStatus(currentScreenData?.GVRT_Status)?.text}}
                    <i *ngIf="getGVRTStatus(currentScreenData?.GVRT_Status)?.['toolTip']" style='color: #9ca3a8;'
                        class="pi pi-info-circle" tooltipPosition="top"
                        pTooltip="{{ currentScreenData?.GVRT_Status === 'SENT' ? currentScreenData?.GVRT_StartDT : currentScreenData?.Error}}"></i>
                </span>
                <download-data *ngIf="getGVRTStatus(currentScreenData?.GVRT_Status)?.text === 'Failed' || getGVRTStatus(currentScreenData?.GVRT_Status)?.text === 'Sent'" [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'GVRT_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Success_KSeF
                    [gvrtStatus]=currentScreenData.GVRT_Status [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [source]="currentScreenData.Source"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'csv'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate"  [disableClass]="downloadFromTable === true">
                </download-data>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="0">{{'text.noData' | translate}}</td>
        </tr>
    </ng-template>
</p-table>
</div>
<p-table *ngIf="countryLocation == 'IT'" #dt [value]="currentScreenData" [paginator]="true"
    [rowsPerPageOptions]="[5, 10, 25, 50]" [rows]="5" [(selection)]="selectedRows" [showCurrentPageReport]="true"
    currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
    sortMode="multiple" [resizableColumns]="true" columnResizeMode="expand" [tableStyle]="{'min-width': 'fit-content'}"
    [globalFilterFields]="['Date', 'System_ID', 'Source', 'FileType', 'FileID', 'OrgFileName', 'Status', 'Total_Received', 'TransformationName', 'Structure','Active_Errors','Active', 'In_Progress_KSeF', 'Success_KSeF', 'Errors_KSeF']">
    <ng-template pTemplate="caption">
        <div class="p-d-flex search-input d-flex justify-content-end">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                    placeholder="{{'text.Searchkeyword' | translate}}" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th rowspan="0" pSortableColumn="Date" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.date' | translate}}
                    <p-columnFilter type="text" field="Date" display="menu"></p-columnFilter>
                    <p-sortIcon field="Date"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="System_ID" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.sysID' | translate}}
                    <p-columnFilter type="text" field="System_ID" display="menu"></p-columnFilter>
                    <p-sortIcon field="System_ID"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="Source" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.source' | translate}}
                    <p-columnFilter type="text" field="Source" display="menu"></p-columnFilter>
                    <p-sortIcon field="Source"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="FileType" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileType' | translate}}
                    <p-columnFilter type="text" field="FileType" display="menu"></p-columnFilter>
                    <p-sortIcon field="FileType"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="FileID" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileID' | translate}}
                    <p-columnFilter type="text" field="FileID" display="menu"></p-columnFilter>
                    <p-sortIcon field="FileID"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" style="width: 10%;" pSortableColumn="OrgFileName" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.fileName' | translate}}
                    <p-columnFilter type="text" field="OrgFileName" display="menu"></p-columnFilter>
                    <p-sortIcon field="OrgFileName"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="Status" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.status' | translate}}
                    <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                    <p-sortIcon field="Status"></p-sortIcon>
                </div>
            </th>
            <th style="display:none;" rowspan="0">{{'text.interMOF' | translate}}</th>
            <th rowspan="0" pSortableColumn="Total_Received" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.totalrec' | translate}}
                    <p-columnFilter type="text" field="Total_Received" display="menu"></p-columnFilter>
                    <p-sortIcon field="Total_Received"></p-sortIcon>
                </div>
            </th>
            <th rowspan="0" pSortableColumn="TransformationName" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.transform' | translate}}
                    <p-columnFilter type="text" field="TransformationName" display="menu"></p-columnFilter>
                    <p-sortIcon field="TransformationName"></p-sortIcon>
                </div>
            </th>
            <th pSortableColumn="Active_Errors" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.activeErr' | translate}}
                    <p-columnFilter type="text" field="Active_Errors" display="menu"></p-columnFilter>
                    <p-sortIcon field="Active_Errors"></p-sortIcon>
                </div>
            </th>
            <th pSortableColumn="Active" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.active' | translate}}
                    <p-columnFilter type="text" field="Active" display="menu"></p-columnFilter>
                    <p-sortIcon field="Active"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="In_Progress_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{ 'text.inprogressSDI' | translate}}
                    <p-columnFilter type="text" field="In_Progress_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="In_Progress_KSeF"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="Success_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.successSDI' | translate}}
                    <p-columnFilter type="text" field="Success_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="Success_KSeF"></p-sortIcon>
                </div>
            </th>
            <th *ngIf='!isManual' pSortableColumn="Errors_KSeF" pResizableColumn>
                <div class="d-flex align-items-center">
                    {{'text.errorsSDI' | translate}}
                    <p-columnFilter type="text" field="Errors_KSeF" display="menu"></p-columnFilter>
                    <p-sortIcon field="Errors_KSeF"></p-sortIcon>
                </div>
            </th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-currentScreenData>
        <tr>
            <td>
                {{currentScreenData.Date | date:'yyyy-MM-dd HH:mm:ss'}}
            </td>
            <td>{{userList[currentScreenData.System_ID] ? userList[currentScreenData.System_ID] :
                currentScreenData.System_ID}}</td>
            <td> {{currentScreenData.Source}}</td>
            <td>
                {{currentScreenData.FileType}}
            </td>
            <td>{{currentScreenData.FileID}}</td>
            <td style="width: 10%; word-break: break-all;">{{currentScreenData.OrgFileName}}</td>
            <td>
                <span *ngIf="currentScreenData.Interfacing_with_MoF === 'AUTO'" class="td-auto file-status"
                    [ngStyle]="{'background-color': setStatusColorEdicom(currentScreenData), 'color': getTextColor(currentScreenData?.Status)}">
                    {{fileStatus1(currentScreenData)?.[currentScreenData?.Status]?.text}}<span
                        *ngIf="inProgressStatusEdicom(currentScreenData)"> -
                        {{progressList[currentScreenData.Stage]}}%</span>
                    <i *ngIf="handleTooltip(currentScreenData)" class="me-2" style='color: #9ca3a8;'
                        class="pi pi-info-circle" pTooltip="{{currentScreenData.Error}}"></i>
                </span>

                <span *ngIf="currentScreenData.Interfacing_with_MoF !== 'AUTO'" class="td-auto file-status"
                    [ngStyle]="{'background-color': setStatusColorNONAuto(currentScreenData), 'color': getTextColor(currentScreenData?.Status)}">
                    {{fileStatus1(currentScreenData)?.[currentScreenData?.Status]?.text}} <span
                        *ngIf="currentScreenData.Interfacing_with_MoF !== 'AUTO' && eyFileStatus(currentScreenData)"> -
                        {{progressList[currentScreenData.Stage]}}%</span>
                    <i *ngIf="toolTipNonAuto(currentScreenData)" class="me-2" style='color: #9ca3a8;'
                        class="pi pi-info-circle" pTooltip="{{currentScreenData.Error}}"></i>
                </span>
                <i *ngIf="currentScreenData?.Status?.toLowerCase() === 'pending'" style='color: #155cb4; cursor: pointer;'
                    class="ms-1 pi pi-upload" [id]="'uploadIcon_' + currentScreenData?.FileID"
                    (click)="openUploadAttachmentDialog(currentScreenData)">
                </i>
            </td>
            <td style="display:none;">{{currentScreenData.Interfacing_with_MoF === "AUTO" ? "Automated"
                : (currentScreenData.Interfacing_with_MoF === "MANUAL" ? "Manual"
                : currentScreenData.Interfacing_with_MoF)}}</td>
            <td *ngIf="currentScreenData.FileStandard === 'EY'" class="download-icon">{{currentScreenData.Total_Received
                || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_TOTAL'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Total_Received
                    [fileStandard]="currentScreenData.FileStandard" [fileExt]="'default'"
                    [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [fileTemplate]="currentScreenData.FileTemplate" [disableClass]="downloadFromTable">
                </download-data>
            </td>
            <td *ngIf="currentScreenData.FileStandard === 'NONEY'" class="download-icon">
                {{currentScreenData.Total_Received || '-' }}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_TOTAL'" [fileId]="currentScreenData.FileID" [count]=currentScreenData.Total_Received
                    [fileStandard]="currentScreenData.FileStandard" [fileExt]="'default'" [bypassCheck]=true
                    [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source" [disableClass]="downloadFromTable"
                    [transform]="currentScreenData.Type" [fileTemplate]="currentScreenData.FileTemplate">
                </download-data >
            </td>
            <td class="download-icon">{{currentScreenData.TransformationName}}
                <download-data *ngIf="currentScreenData.FileStandard === 'NONEY' && currentScreenData.Status !== 'PREUPLOADED'
                && currentScreenData.Status !== 'T_INPROGRESS'" [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate"
                    [fileName]="currentScreenData.FileName" [fileType]="'EY_TRANSFORMATION'" [disableClass]="downloadFromTable"
                    [fileId]="currentScreenData.FileID" [count]=currentScreenData.Transformation [bypassCheck]=true
                    [fileExt]="'csv'" [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                     [transform]="currentScreenData.Type" [fileStatus]="noneyfileStatusList[currentScreenData.Status]
                ? noneyfileStatusList[currentScreenData.Status]['text'] : currentScreenData.Status"
                    [fileTemplate]="currentScreenData.FileTemplate"></download-data>
            </td>
            <td class="download-icon">{{currentScreenData.Active_Errors || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_ACTIVE_ERRORS_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Active_Errors [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [transform]="currentScreenData.Type" [disableClass]="downloadFromTable"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName" [source]="currentScreenData.Source"
                    [fileTemplate]="currentScreenData.FileTemplate" [fileStatus] = "currentScreenData.Status"
                    [errorMsg] = "currentScreenData.Error" [isPopupApplicable] = "true" [dbFileStatus] = "currentScreenData.dbStatus">
                </download-data>
            </td>
            <td class="download-icon">{{currentScreenData.Active || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'EY_ACTIVE_'+countryLocation" [fileId]="currentScreenData.FileID" [disableClass]="downloadFromTable"
                    [count]=currentScreenData.Active [source]="currentScreenData.Source" [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [transform]="currentScreenData.Type" [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate" [fileStatus] = "currentScreenData.Status"
                    [errorMsg] = "currentScreenData.Error" [isPopupApplicable] = "true" [dbFileStatus] = "currentScreenData.dbStatus">
                </download-data>
            </td>
            <td *ngIf='!isManual'>{{currentScreenData.In_Progress_KSeF || 0}}
            </td>
            <td *ngIf='!isManual' class="download-icon">{{currentScreenData.Success_KSeF || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'MOF_SUCCESS_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Success_KSeF [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [source]="currentScreenData.Source" [disableClass]="downloadFromTable"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate" [fileStatus] = "currentScreenData.Status"
                    [errorMsg] = "currentScreenData.Error" [isPopupApplicable] = "true" [dbFileStatus] = "currentScreenData.dbStatus">
                </download-data>
            </td>
            <td *ngIf='!isManual' class="download-icon">{{currentScreenData.Errors_KSeF || 0}}
                <download-data [type]="'anchor'" [date]="currentScreenData.Date" [downloadDate]="currentScreenData.DownloadDate" [fileName]="currentScreenData.FileName"
                    [fileType]="'MOF_ERROR_'+countryLocation" [fileId]="currentScreenData.FileID"
                    [count]=currentScreenData.Errors_KSeF [mofInterface]="currentScreenData.Interfacing_with_MoF"
                    [source]="currentScreenData.Source" [disableClass]="downloadFromTable"
                    [transform]="currentScreenData.Type"
                    [fileExt]="'xlsx'" [orgFileName]="currentScreenData.OrgFileName"
                    [fileTemplate]="currentScreenData.FileTemplate" [fileStatus] = "currentScreenData.Status"
                    [errorMsg] = "currentScreenData.Error" [isPopupApplicable] = "true" [dbFileStatus] = "currentScreenData.dbStatus">
                </download-data>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="0">{{'text.noData' | translate}}</td>
        </tr>
    </ng-template>
</p-table>